import React from 'react';
import clsx from 'clsx';
import { TICK_LENGTH, TICK_MARGIN } from './utils';
import styles from './styles.css.js';
export function VerticalGridLines(_a) {
    var ticks = _a.ticks, scale = _a.scale, innerHeight = _a.innerHeight;
    return (React.createElement("g", { "aria-hidden": "true" }, ticks.map(function (yValue) {
        var _a;
        var x = (_a = scale.d3Scale(yValue)) !== null && _a !== void 0 ? _a : NaN;
        return (isFinite(x) && (React.createElement("line", { key: "vertical-grid-" + yValue, className: styles.grid, x1: x, y1: 0, x2: x, y2: innerHeight })));
    })));
}
export function EmphasizedBaseline(_a) {
    var _b;
    var axis = _a.axis, yScale = _a.yScale, innerWidth = _a.innerWidth, innerHeight = _a.innerHeight;
    // Y position of the zero baseline, if it exists
    var baselineY = (_b = yScale.d3Scale(0)) !== null && _b !== void 0 ? _b : NaN;
    var showYBaseline = axis === 'x' && isFinite(baselineY) && baselineY <= innerHeight;
    if (showYBaseline) {
        return (React.createElement("line", { className: clsx(styles.axis, styles['axis--emphasized']), x1: -TICK_MARGIN, x2: innerWidth, y1: baselineY, y2: baselineY, "aria-hidden": "true" }));
    }
    if (axis === 'y') {
        return (React.createElement("line", { className: clsx(styles.axis, styles['axis--emphasized']), x1: 0, y1: 0, x2: 0, y2: innerHeight + TICK_LENGTH, "aria-hidden": "true" }));
    }
    return null;
}
//# sourceMappingURL=grid.js.map